export default __webpack_public_path__ + "static/media/default.5630c577.wav";